module.exports = __webpack_public_path__ + "static/media/classic-html-head.eb53e9c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/modern-javascript/assets/classic-html-head.png
// module id = 1529
// module chunks = 0